import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import ModelPane from 'src/components/global-settings/ModelPane'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    makes: state.vehicleCreateOptions.makes
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelPane)



// WEBPACK FOOTER //
// ./src/containers/global-settings/ModelPane.ts